import SectionLandingHero from './SectionLandingHero';
export default SectionLandingHero;
